import React, { useContext, memo } from 'react';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import Logo from '@prisjakt/ui-logo';
import './header.scss';

const styles = bemGenerator('legacy-header');

const LegacyHeader = () => {
  const context = useContext(AppContext);
  return (
    <div className={styles.block}>
      <a href="/">
        <Logo
          market={context.market.code}
          companyName={context.t('meta', 'market.logo-alt')}
        />
      </a>
    </div>
  );
};

export default memo(LegacyHeader);
